import "./assets/css/flaticon.css";
import "./assets/css/animate.min.css";
import "uikit/dist/css/uikit.min.css";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import "./assets/css/skeleton.css";

import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Preloader from "./components/Common/Preloader";
import HomeTwo from "./components/Pages/HomeTwo";
import ScrollProgress from "./components/Common/ScrollProgress";
import ErrorBoundary from "./components/Common/ErrorBoundary";
import { usePerformance } from "./hooks/usePerformance";

const App = () => {
  const [loading, setLoading] = useState(true);

  // Performance monitoring
  usePerformance();

  useEffect(() => {
    // Remove artificial delay - load as soon as the app is ready
    const loadApp = () => {
      // Only show loading for a minimum time to prevent flash
      const minLoadTime = 500; // 500ms minimum
      const startTime = Date.now();

      const finishLoading = () => {
        const elapsed = Date.now() - startTime;
        const remainingTime = Math.max(0, minLoadTime - elapsed);

        setTimeout(() => {
          setLoading(false);
        }, remainingTime);
      };

      // Check if critical resources are loaded
      if (document.readyState === "complete") {
        finishLoading();
      } else {
        window.addEventListener("load", finishLoading);
        return () => window.removeEventListener("load", finishLoading);
      }
    };

    loadApp();
  }, []);

  return (
    <ErrorBoundary>
      <Router>
        <>
          <ScrollProgress />
          {loading ? <Preloader /> : ""}
          <Routes>
            <Route path="/" element={<HomeTwo />} />
          </Routes>
        </>
      </Router>
    </ErrorBoundary>
  );
};

export default App;
